'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var orange = {};

exports.__exports = orange;
